// import BudgetDowload from 'PDF/Presupuesto/BudgetDowload/BudgetDowload';
import Dowload from 'PDF/AttentionVoucher/Dowload/Dowload';
import { notification } from 'antd';
import { getAccessTokenApi } from 'api/auth';
import axios from 'axios';
import { API_PATH } from 'config';
import { createContext, useContext } from 'react';
import { getImagesVoucher } from 'api/attentionVoucher';
import { getStaticVoucherData } from 'api/budget';

const ActionsComprobantesContext = createContext(null);

export const ActionsComprobantesProvider = ({ children }) => {
  const dowload = async (id) => {
    const token = getAccessTokenApi();

    try {
      // Obtener datos del voucher
      const voucherData = await axios
        .get(`${API_PATH}/get-attention-vouchers/${id}`, {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => response.data);

      // Obtener configuración estática
      const staticData = await getStaticVoucherData(token);
      const config = staticData?.tenant || {};
      // Obtener imágenes del voucher
      const imagesData = await getImagesVoucher(id);
      const images = imagesData?.images || [];

      // Preparar datos completos para el componente
      const completeData = {
        voucher: voucherData,
        config: config,
        images: images,
      };

      notification.open({
        duration: 30,
        message: `Descargar Comprobante N°"${id}"`,
        btn: <Dowload {...completeData} />,
      });
    } catch (error) {

      notification.error({
        message: 'Error',
        description: 'No se pudieron obtener los datos del comprobante',
      });
    }
  };

  return (
    <ActionsComprobantesContext.Provider
      value={{
        dowload,
      }}
    >
      {children}
    </ActionsComprobantesContext.Provider>
  );
};

export const useActionsComprobantes = () =>
  useContext(ActionsComprobantesContext);
